export function triggerNav(id) {
    let shadeDom = document.getElementById('shadeBack' + id);
    let menuDivDom = document.getElementById('menuDiv' + id);
    if (!shadeDom.style.display || shadeDom.style.display == "none") {
        menuDivDom.style.maxWidth = '500px';
        shadeDom.style.display = 'block';
    }else {
        menuDivDom.style.maxWidth = '0';
        shadeDom.style.display = 'none';
    }
}
export function checkedNav(event) {
    let currentNode = event.target;
    if (event.target.classList.contains('cutBox')) {
        currentNode = event.target.parentNode;
    }
    if (currentNode.classList.contains('active') == false) {
        currentNode.classList.add('active');
    }else {
        currentNode.classList.remove('active');
    }
}